export default __webpack_public_path__ + "static/media/LifestyleCancellationPageDesktopHeader1.e0e8df8d.jpg";